const PARTNER = {
  SET_PARTNER_QUERY: 'SET_PARTNER_QUERY',
};

export default PARTNER;
